import React from 'react';
export function ProblemSection() {
  return <section className="bg-[#0B0B12] py-16 px-5 relative overflow-hidden" data-id="element-236">
      <div className="blur-circle bg-brand-blueDeep/20 top-0 right-0" data-id="element-237" />
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-238">
        <div className="p-0" data-id="element-239">
          <h2 className="text-2xl md:text-3xl font-black text-white mb-8 leading-tight text-center uppercase tracking-tight" data-id="element-240">
            😩 ¿TE PASA ESTO EN TU DÍA A DÍA? <br data-id="element-241" />
            <span className="text-red-500 text-lg md:text-xl block mt-2 font-bold" data-id="element-242">
              Te levantás sabiendo que te espera otro día resolviendo mil cosas
              a la vez.
            </span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-12" data-id="element-243">
            {['Respondés consultas según cómo venga cada conversación', 'Algunas clientas te drenan energía porque todo depende de cómo expliques o resuelvas en el momento', 'Dudás cuánto cobrar o cómo justificar presupuestos sin incomodidad', 'Tu agenda, organización o flujo diario se vuelven caóticos', 'Sentís que apagás incendios todo el tiempo', 'Te cuesta sostener procesos claros porque todo cambia según el caso', 'Aunque técnicamente trabajás bien, a veces sentís desorden interno', 'Terminás agotada porque TODO depende de vos', 'Querés trabajar como una profesional más estructurada… pero seguís improvisando demasiadas cosas'].map((problem, idx) => <div key={idx} className="bg-white/5 backdrop-blur-sm border border-white/10 p-5 rounded-2xl flex items-start gap-4 transition-all hover:bg-white/10 hover:border-brand-gold/30 shadow-xl" data-id="element-244">
                <span className="text-red-500 text-lg flex-shrink-0" data-id="element-245">❌</span>
                <p className="text-sm text-slate-300 font-medium leading-relaxed" data-id="element-246">
                  {problem}
                </p>
              </div>)}
          </div>

          <div className="text-center mb-8 max-w-2xl mx-auto" data-id="element-247">
            <h3 className="text-xl md:text-2xl font-black mb-4 text-white uppercase tracking-tight" data-id="element-248">
              ¿CUÁNTO TIEMPO MÁS VAS A SEGUIR SOSTENIENDO UN NEGOCIO O TRABAJO
              QUE DEPENDE DE IMPROVISAR TODO?
            </h3>
            <p className="text-slate-400 font-bold italic" data-id="element-249">
              Porque muchas veces el agotamiento NO viene del trabajo en sí.
              Viene de no tener estructura.
            </p>
          </div>

          <div className="bg-gradient-to-br from-[#0D1B3D] to-[#0B0B12] border-2 border-brand-gold/20 p-8 rounded-3xl mt-8 shadow-2xl relative overflow-hidden" data-id="element-250">
            <div className="absolute top-0 right-0 w-64 h-64 bg-brand-gold/5 blur-3xl rounded-full -mr-32 -mt-32" data-id="element-251"></div>
            <p className="gold-text-gradient font-black text-xl mb-8 text-center uppercase tracking-widest" data-id="element-252">
              ESTO ES LO QUE CAMBIA CUANDO EMPEZÁS A TRABAJAR CON EL SISTEMA
              PELUQUERÍA LISTA™:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6" data-id="element-253">
              {['Respondés con más seguridad', 'Improvisás muchísimo menos', 'Organizás mejor tu día', 'Reducís caos operativo', 'Mejorás cómo te perciben tus clientas', 'Cobrás con más claridad', 'Tenés procesos más consistentes', 'Ahorrás energía mental', 'Ganás más sensación de control', 'Trabajás con mucho más criterio profesional'].map((item, i) => <div key={i} className="flex items-center gap-4" data-id="element-254">
                  <div className="bg-brand-gold/10 w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 border border-brand-gold/20" data-id="element-255">
                    <span className="text-brand-gold font-black text-lg" data-id="element-256">
                      ✔
                    </span>
                  </div>
                  <p className="text-slate-200 text-sm md:text-base font-black uppercase tracking-tight" data-id="element-257">
                    {item}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}